import { mangas } from '@/mocks/mangas';
import MangaCard from '@/components/base/MangaCard';
import { Link } from 'react-router-dom';

export default function LatestSection() {
  const latestMangas = [...mangas]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="latest-section-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 id="latest-section-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新上线
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-2">刚刚更新的热门漫画，精彩不容错过</p>
          </div>
          <Link
            to="/category"
            className="hidden md:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {latestMangas.map((manga) => (
            <MangaCard
              key={manga.id}
              id={manga.id}
              title={manga.title}
              author={manga.author}
              cover={manga.cover}
              category={manga.category}
              rating={manga.rating}
              tags={manga.tags}
              status={manga.status}
              views={manga.views}
            />
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-primary-500 text-sm font-medium"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}